import { useDispatch, useSelector } from "react-redux";
import {
  isSingleSleeperSelector, primarySleeperHeightFeetSelector, primarySleeperHeightInchesSelector,
  primarySleeperUnitSystemSelector,
  secondarySleeperUnitSystemSelector,
  setPrimarySleeperUnitSystem,
  setSecondarySleeperUnitSystem,
} from "../../../../redux/slices/mattressConfiguration";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import BedBuilderHeader from "../../SingleBedBuilder/common/BedBuilderHeader";
import BodyTypeRadioGroup from "../../SingleBedBuilder/HeightAndWeight/BodyTypeRadioGroup";
import EvrbedSwitch from "../../../../components/Switch/EvrbedSwitch";

import React from "react";

import UnitInput from "../../../../components/Inputs/UnitInput";

import styled from "styled-components";
import ImperialInput from "../../../../components/Inputs/ImperialInput";

const StyledHeightWeightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledInputLabel = styled.div`
  font-family: noto-sans;
`;

const HeightAndWeightControls = ({ editingSleeper1 }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();

  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const primarySleeperHeightFeet = useSelector(primarySleeperHeightFeetSelector);
  const primarySleeperHeightInches = useSelector(primarySleeperHeightInchesSelector);
  const primarySleeperUnitSystem = useSelector(
    primarySleeperUnitSystemSelector
  );
  const secondarySleeperUnitSystem = useSelector(
    secondarySleeperUnitSystemSelector
  );
  const handleOnChange = event => {
    if (isSingleSleeper || editingSleeper1) {
      dispatch(setPrimarySleeperUnitSystem(!event.target.checked));
    } else {
      dispatch(setSecondarySleeperUnitSystem(!event.target.checked));
    }
  };

  const unitValue =
    isSingleSleeper || editingSleeper1
      ? primarySleeperUnitSystem
      : secondarySleeperUnitSystem;

  return (
    <>
      <BedBuilderHeader className={"bed-builder-header"} styles={{ marginTop: "1rem" }}>
        {t("Let's Calculate Your evr-index:")}
      </BedBuilderHeader>
      <EvrbedSwitch
        labelLeft={t("Imperial")}
        labelRight={t("Metric")}
        textStyles={{ color: theme.COLORS.BLUE.darkBlueGreen }}
        containerStyles={{ marginTop: "1rem" }}
        onChange={handleOnChange}
        value={unitValue !== "imperial"}
      ></EvrbedSwitch>
      <StyledHeightWeightContainer className="row mt-3 mx-5 height-and-weight">
        <div className="col-5">
          <StyledInputLabel
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
            }}
          >
            {t("Height")}
          </StyledInputLabel>
          {editingSleeper1 &&
            <>
              {unitValue === "metric" &&
                <UnitInput
                  editingSleeper1={editingSleeper1}
                  unit="height"
                  label={"Height"}
                  placeholder={"cm"}
                />
              }
              {unitValue !== "metric" &&
                <>
                  <ImperialInput
                    editingSleeper1={editingSleeper1}
                    unit="height"
                    label={"Height"}
                    placeholder={"feet"}
                  />
                  <ImperialInput
                    editingSleeper1={editingSleeper1}
                    unit="height"
                    label={"Height"}
                    placeholder={"inches"}
                  />
                </>
              }
            </>
          }
          {!editingSleeper1 &&
            <>
              {unitValue === "metric" &&
                <UnitInput
                  editingSleeper1={editingSleeper1}
                  unit="height"
                  label={"Height"}
                  placeholder={"cm"}
                />
              }
              {unitValue !== "metric" &&
                <>
                  <ImperialInput
                    editingSleeper1={editingSleeper1}
                    unit="height"
                    label={"Height"}
                    placeholder={"feet"}
                  />
                  <ImperialInput
                    editingSleeper1={editingSleeper1}
                    unit="height"
                    label={"Height"}
                    placeholder={"inches"}
                  />
                </>
              }
            </>
          }
        </div>
        <div className="col-5">
          <StyledInputLabel
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
            }}
          >
            {t("Weight")}
          </StyledInputLabel>
          <UnitInput
            editingSleeper1={editingSleeper1}
            unit="weight"
            label={"Weight"}
            placeholder={unitValue === "metric" ? "kg" : "lbs"}
          />
        </div>
      </StyledHeightWeightContainer>
      <BedBuilderHeader styles={{ marginTop: "0.5rem" }}>
        {t("What Is Your Body Type?")}
      </BedBuilderHeader>
      <BodyTypeRadioGroup
        editingSleeper1={editingSleeper1}
      ></BodyTypeRadioGroup>
    </>
  );
};

export default HeightAndWeightControls;
